/* GOLDN DESIGNER — Street Edition (v11) */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const GD = window.GD || { routes: {}, t: {} };
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motion = document.body.classList.contains('has-motion') && !reduce;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const root = (GD.routes && GD.routes.root) || '/';
  const url = (p) => (root.endsWith('/') ? root : root + '/') + p.replace(/^\//, '');

  /* ---------- money ---------- */
  function money(cents, format) {
    format = format || GD.moneyFormat || '€{{amount_with_comma_separator}}';
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    const fmt = (n, d = 2, t = ',', dec = '.') => {
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(d);
      const parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, '.', ',');
      }
    });
  }

  /* ---------- toast ---------- */
  const toastEl = $('[data-toast]');
  let toastT;
  function toast(msg, err) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.toggle('is-err', !!err);
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  }

  /* ---------- scroll progress + header ---------- */
  const bar = $('[data-scroll-bar]');
  const hdr = $('[data-header]');
  let ticking = false;
  function onScroll() {
    const h = document.documentElement.scrollHeight - innerHeight;
    if (bar) bar.style.setProperty('--s', h > 0 ? (scrollY / h).toFixed(4) : 0);
    if (hdr) hdr.classList.toggle('is-scrolled', scrollY > 10);
    parallax();
    manifesto();
    ticking = false;
  }
  addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });

  /* ---------- overlay helpers ---------- */
  let lastFocus = null;
  function openLayer(el, trigger) {
    if (!el) return;
    lastFocus = trigger || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('button, a, input');
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 80);
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .cd.is-open, .fdrawer.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .cd.is-open, .fdrawer.is-open').forEach(closeLayer);
    const s = $('[data-search]'); if (s && !s.hidden) s.hidden = true;
  });

  /* nav drawer */
  const drawer = $('[data-drawer]');
  $$('[data-drawer-open]').forEach((b) => b.addEventListener('click', () => { openLayer(drawer, b); b.setAttribute('aria-expanded', 'true'); }));
  $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => { closeLayer(drawer); $$('[data-drawer-open]').forEach((x) => x.setAttribute('aria-expanded', 'false')); }));

  /* search */
  const search = $('[data-search]');
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', () => {
    if (!search) return;
    search.hidden = !search.hidden;
    if (!search.hidden) setTimeout(() => $('input[type=search]', search).focus(), 30);
  }));
  $$('[data-search-close]').forEach((b) => b.addEventListener('click', () => { if (search) search.hidden = true; }));

  /* ---------- cart drawer ---------- */
  const cd = () => $('[data-cart-drawer]');
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && cd() && !document.body.classList.contains('t-cart')) { e.preventDefault(); openLayer(cd(), open); return; }
    if (e.target.closest('[data-cart-close]') || e.target.matches('.cd')) { closeLayer(cd()); return; }
    if (e.target.matches('.drawer.is-open, .fdrawer')) { closeLayer(e.target); return; }
    const ch = e.target.closest('[data-line-change]');
    if (ch) { e.preventDefault(); changeLine(ch.dataset.lineChange, ch.dataset.qty); }
  });

  async function refreshCart(open) {
    try {
      const res = await fetch(url('?sections=gd-cart-drawer'));
      const data = await res.json();
      const html = data['gd-cart-drawer'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-drawer]');
        const cur = cd();
        if (fresh && cur) {
          cur.querySelector('.cd__panel').replaceWith(fresh.querySelector('.cd__panel'));
        }
      }
      const cart = await fetch(url('cart.js')).then((r) => r.json());
      $$('[data-cart-count]').forEach((c) => {
        c.textContent = cart.item_count;
        c.classList.toggle('is-empty', cart.item_count === 0);
        c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
      });
      if (open) openLayer(cd());
    } catch (err) { /* fall back silently */ }
  }

  async function changeLine(line, qty) {
    const el = cd(); if (el) el.classList.add('is-loading');
    try {
      await fetch(url('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(qty)) }) });
      await refreshCart(false);
    } catch (e) { toast(GD.t.error, true); }
    const el2 = cd(); if (el2) el2.classList.remove('is-loading');
  }

  /* ajax add (product form + quick add) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form.js-add');
    if (!form) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    if (document.body.classList.contains('t-cart')) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]') || e.submitter;
    const err = form.querySelector('[data-form-error]');
    if (btn) btn.classList.add('is-loading');
    if (err) err.hidden = true;
    try {
      const res = await fetch(url('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || GD.t.error);
      await refreshCart(true);
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; }
      toast(ex.message || GD.t.error, true);
    } finally { if (btn) btn.classList.remove('is-loading'); }
  });

  /* qty steppers */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    if (!input) return;
    const min = input.min !== '' ? Number(input.min) : 0;
    input.value = Math.max(min, (Number(input.value) || 0) + Number(b.dataset.qtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  /* cart page autosubmit */
  let autoT;
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-autosubmit]')) return;
    clearTimeout(autoT);
    autoT = setTimeout(() => {
      const f = e.target.form;
      if (f) { const h = document.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = '1'; f.appendChild(h); f.submit(); }
    }, 500);
  });

  /* confirm forms */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-confirm]');
    if (f && !window.confirm(f.dataset.confirm)) e.preventDefault();
  });

  /* ---------- variant picker ---------- */
  $$('[data-product]').forEach((sec) => {
    const picker = $('[data-variant-picker]', sec);
    const idInput = $('[data-variant-id]', sec);
    const addBtn = $('[data-add-btn]', sec);
    const addText = $('[data-add-text]', sec);
    const sticky = $('[data-sticky-buy]', sec);
    const stickyAdd = $('[data-sticky-add]', sec);
    const stickyPrice = $('[data-sticky-price]', sec);
    if (picker) {
      const variants = JSON.parse(($('[data-variants]', picker) || {}).textContent || '[]');
      const radios = $$('input[type=radio]', picker);
      const update = () => {
        const fieldsets = $$('fieldset', picker);
        const sel = fieldsets.map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
        fieldsets.forEach((fs, i) => { const l = $('[data-opt-label="' + i + '"]', picker); if (l) l.textContent = sel[i]; });
        // availability marks
        radios.forEach((r) => {
          const idx = Number(r.dataset.optIndex);
          const test = sel.slice(); test[idx] = r.value;
          const ok = variants.some((v) => v.options.every((o, i) => o === test[i]) && v.available);
          r.closest('.opt__v').classList.toggle('is-na', !ok);
        });
        const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addText) addText.textContent = GD.t.unavailable;
          if (stickyAdd) stickyAdd.disabled = true;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (addBtn) addBtn.disabled = !v.available;
        if (stickyAdd) stickyAdd.disabled = !v.available;
        if (addText) addText.textContent = v.available ? GD.t.add : GD.t.soldOut;
        const pr = $('[data-price]', sec);
        if (pr) {
          const now = $('[data-price-now]', pr), was = $('[data-price-was]', pr);
          if (now) now.textContent = money(v.price);
          if (was) was.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
          pr.classList.toggle('price--sale', v.compare_at_price > v.price);
          let off = $('[data-price-off]', pr);
          if (v.compare_at_price > v.price) {
            if (!off) { off = document.createElement('span'); off.className = 'price__off'; off.dataset.priceOff = ''; pr.appendChild(off); }
            off.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          } else if (off) off.remove();
        }
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (v.featured_media) {
          const m = $('[data-media-id="' + v.featured_media.id + '"]', sec);
          const gal = $('[data-gallery]', sec);
          if (m && gal) {
            if (getComputedStyle(gal).display === 'flex') gal.scrollTo({ left: m.offsetLeft, behavior: 'smooth' });
            else if (m !== gal.firstElementChild) gal.prepend(m);
          }
        }
        if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      };
      radios.forEach((r) => r.addEventListener('change', update));
      update();
    }
    /* gallery dots */
    const gal = $('[data-gallery]', sec), dots = $$('[data-gallery-dots] span', sec);
    if (gal && dots.length) {
      gal.addEventListener('scroll', () => {
        const i = Math.round(gal.scrollLeft / gal.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-on', i === j));
      }, { passive: true });
    }
    /* sticky buy */
    const form = $('form.pform', sec);
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
      }).observe(form);
    }
  });

  /* share */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-share]');
    if (!b) return;
    const data = { title: b.dataset.title, url: b.dataset.url };
    try {
      if (navigator.share) await navigator.share(data);
      else { await navigator.clipboard.writeText(data.url); toast(GD.t.copied); }
    } catch (_) {}
  });

  /* ---------- recommendations ---------- */
  $$('[data-recs]').forEach(async (el) => {
    if (el.children.length && el.querySelector('.card')) return;
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; observe(el); }
    } catch (_) {}
  });

  /* ---------- collection ---------- */
  const filters = $('[data-filters]');
  $$('[data-filters-open]').forEach((b) => b.addEventListener('click', () => openLayer(filters, b)));
  $$('[data-filters-close]').forEach((b) => b.addEventListener('click', () => closeLayer(filters)));
  const ff = $('[data-filter-form]');
  if (ff) ff.addEventListener('submit', (e) => {
    e.preventDefault();
    const params = new URLSearchParams(new FormData(ff));
    for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
    location.search = params.toString();
  });
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u;
  }));
  const grid = $('[data-grid]');
  const setDensity = (d) => {
    if (!grid) return;
    grid.classList.toggle('is-2', d === '2');
    $$('[data-density]').forEach((b) => b.classList.toggle('is-on', b.dataset.density === d));
  };
  try { const d = localStorage.getItem('gd-density'); if (d) setDensity(d); } catch (_) {}
  $$('[data-density]').forEach((b) => b.addEventListener('click', () => {
    setDensity(b.dataset.density);
    try { localStorage.setItem('gd-density', b.dataset.density); } catch (_) {}
  }));

  /* ---------- login recover toggle ---------- */
  const loginV = $('[data-login-view]'), recV = $('[data-recover-view]');
  const showRecover = (on) => { if (loginV && recV) { loginV.hidden = on; recV.hidden = !on; } };
  if (location.hash === '#recover') showRecover(true);
  $$('[data-recover-open]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); showRecover(true); }));
  $$('[data-recover-close]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); showRecover(false); }));

  /* ---------- hero: compare slider ---------- */
  $$('[data-compare]').forEach((cmp) => {
    const range = $('[data-compare-range]', cmp);
    if (!range) return;
    const set = (v) => cmp.style.setProperty('--pos', v + '%');
    range.addEventListener('input', () => { cmp.classList.remove('is-sweeping'); set(range.value); });
    // pointer drag on whole frame (touch friendly)
    let dragging = false;
    const fromEvent = (e) => {
      const r = cmp.getBoundingClientRect();
      const x = Math.min(Math.max(((e.clientX - r.left) / r.width) * 100, 0), 100);
      range.value = Math.round(x); set(x);
    };
    cmp.addEventListener('pointerdown', (e) => { dragging = true; cmp.classList.remove('is-sweeping'); fromEvent(e); });
    addEventListener('pointermove', (e) => { if (dragging) fromEvent(e); }, { passive: true });
    addEventListener('pointerup', () => { dragging = false; });
    // intro sweep
    if (motion) {
      cmp.classList.add('is-sweeping');
      const seq = [[400, 18], [1700, 84], [3000, 50]];
      seq.forEach(([t, v]) => setTimeout(() => { if (cmp.classList.contains('is-sweeping')) { range.value = v; set(v); } }, t));
      setTimeout(() => cmp.classList.remove('is-sweeping'), 4300);
    } else set(50);
  });

  /* hero glow follows pointer */
  const hero = $('[data-hero]'), glow = $('[data-glow]');
  if (hero && glow && fine && motion) {
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      glow.style.setProperty('--gx', (e.clientX - r.left) + 'px');
      glow.style.setProperty('--gy', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---------- split words ---------- */
  $$('[data-split]').forEach((el) => {
    if (el.dataset.splitDone) return;
    const words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach((w, i) => {
      const o = document.createElement('span'); o.className = 'w';
      const s = document.createElement('span'); s.textContent = w; s.style.setProperty('--wi', i);
      o.appendChild(s); el.appendChild(o);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el.dataset.splitDone = '1';
    el.classList.add('reveal-split');
  });
  /* footer letters */
  $$('[data-split-letters]').forEach((el) => {
    const t = el.textContent; el.textContent = '';
    [...t].forEach((ch) => { const s = document.createElement('span'); s.className = 'lt'; s.textContent = ch === ' ' ? ' ' : ch; el.appendChild(s); });
  });

  /* ---------- reveal ---------- */
  let io;
  function observe(scope = document) {
    const els = $$('.reveal, [data-split]', scope);
    if (!motion || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    if (!io) io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((e) => io.observe(e));
  }
  observe();

  /* ---------- parallax ---------- */
  const px = $$('[data-parallax]');
  function parallax() {
    if (!motion) return;
    px.forEach((f) => {
      const r = f.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      const img = f.querySelector('img'); if (img) img.style.setProperty('--py', (p * -60).toFixed(1) + 'px');
    });
  }
  /* manifesto fill */
  const lines = $$('[data-fill]');
  function manifesto() {
    lines.forEach((l) => {
      const r = l.getBoundingClientRect();
      const p = Math.min(Math.max((innerHeight * 0.85 - r.top) / (innerHeight * 0.5), 0), 1);
      l.style.setProperty('--f', (p * 100).toFixed(1) + '%');
    });
  }

  /* ---------- magnetic + tilt ---------- */
  if (fine && motion) {
    $$('[data-magnetic]').forEach((b) => {
      b.addEventListener('pointermove', (e) => {
        const r = b.getBoundingClientRect();
        b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.18}px, ${(e.clientY - r.top - r.height / 2) * 0.28}px)`;
      });
      b.addEventListener('pointerleave', () => { b.style.transform = ''; });
    });
    $$('[data-tilt]').forEach((c) => {
      c.addEventListener('pointermove', (e) => {
        const r = c.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = `rotateY(${x * 10}deg) rotateX(${y * -10}deg) translateZ(0)`;
      });
      c.addEventListener('pointerleave', () => { c.style.transform = ''; });
    });
  }

  /* ---------- ready ---------- */
  requestAnimationFrame(() => { document.body.classList.add('is-ready'); onScroll(); });
})();
